import { FabricObject } from 'fabric';

import { DRAW_OBJECT_TYPE_CIRCLE } from '../draw-canvas.constants';

export const isCircle = (object: FabricObject) => {
  return object.type.toLowerCase() === DRAW_OBJECT_TYPE_CIRCLE;
};
